/******************************************************************************
### DOCUMENTATION: (How do I use this Directive) ###
The directive will update the breadcrumb at the top of page. The breadcrumb must
be on the page already for this directive to update it.

** Add this imports to your app.ts file **
import { UPSBreadcrumb } from '../../../../common/apps/assets/angular/datepicker_official';


** Add the component to the declarations of your app. **
UPSBreadcrumb


** On the template that needs to update the breadcrumb, add this attribute **
<div [breadcrumb]="[{link : '#/', name : 'Main Page'}]">


** Breadcrumb object **
[
    {
        link : '#/',    // the anchor link location to fill in the href
        name : 'Main'   // the text to fill in for the anchor
    },
    {
        link : '#/add',
        name : 'Add'
    }
]


*******************************************************************************/

import { Directive, ElementRef, Renderer2, HostListener, Input, OnInit, AfterViewInit } from '@angular/core';
import { BreadcrumbItem } from './breadcrumbItem';

declare var $: any;

@Directive({
    selector: '[breadcrumb]'
})
export class UPSBreadcrumb implements OnInit {
    @Input('breadcrumb') breadcrumb: Array<BreadcrumbItem>;

    constructor(private el: ElementRef, private render: Renderer2) {
    }

    ngOnInit() {
        $('.ups-breadcrumb ol').html('');

        //$('ups-breadcrumb-item').replaceWith('')

        if (this.breadcrumb) {
            for (var n = 0; n < this.breadcrumb.length; n++) {
                if (n == (this.breadcrumb.length - 1)) {
                    $('.ups-breadcrumb ol').append('<li class="ups-breadcrumb-item">' + this.breadcrumb[n].name + '</li>');
                } else {
                    $('.ups-breadcrumb ol').append('<li class="ups-breadcrumb-item"><a href="' + this.breadcrumb[n].link + '" class="ups-link">' + this.breadcrumb[n].name + '</a><span aria-hidden="true"> &gt;</span></li>');
                }
            }
        }
    } 
}
